module.exports = __webpack_public_path__ + "img/wuLong5.b31fdc65.png";